import React, { useEffect, useState } from "react";
import {
  PsrCaptureProfile,
} from "../../../../Model/CaptureProfile";
import EOpticAndCameraFeature from "../../../../Model/EOpticAndCameraFeature";
import { Binning } from "../../../../Model/ImagerCapabilities";
import {
  BaseControl,
  FeatureLabel,
  UnitRadio,
} from "../../../Imager/ImagerFeatureControls";

type BinningControlProps = {
  binning: Binning;
  captureProfile:PsrCaptureProfile;
  onChange: (value: { binning: number }) => void;
  disabled: boolean;
};

export function PsrBiningControl({
  binning,
  captureProfile,
  onChange,
  disabled,
}: BinningControlProps) {
  const [biningValue, setBinningValue] = useState(captureProfile.binning);

  if (captureProfile.binning == null) {
    throw new Error("Capture profile binning is null");
  }

  useEffect(() => {
    setBinningValue(captureProfile.binning);
  }, [captureProfile.binning]);

  const onBiningChanged = (binning: number) => {
    setBinningValue(binning);
    onChange({ binning: binning });
  };

  var options = binning.binningDisplayValues.map((binningDisplayValue) => {
    const { binning } = binningDisplayValue;
    const display = binning + "x" + binning + " binning";

    return (
      <UnitRadio
        id={display}
        disabled={disabled}
        key={binning}
        label={display}
        onValueChanged={() => onBiningChanged(binning)}
        checked={biningValue === binning}
      />
    );
  });

  return (
    <BaseControl
      id={EOpticAndCameraFeature.Binning}
      key={EOpticAndCameraFeature.Binning}
      disabled={disabled}
    >
      <FeatureLabel disabled={disabled}>{"Binning:"}</FeatureLabel>
      <div
        style={{
          display: "flex",
          flexGrow: 1,
          marginLeft: 5,
          marginRight: 15,
          flexDirection: "row",
        }}
      >
        {options}
      </div>
    </BaseControl>
  );
}
